import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faCircleXmark } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

interface ClearChipsButtonProps {
	/** Nothing to clear renders nothing — the box keeps its plain look. */
	visible: boolean;
	onClear: () => void;
}

/**
 * Empties a chip input in one click. A generated rubric bucket routinely holds
 * twenty-odd countries, and rebuilding one from scratch meant hitting that many
 * individual ✕ (PREC-3719).
 *
 * `mousedown` is suppressed so the click cannot blur the text input first — on
 * the free-text inputs that would commit whatever was half-typed and leave a
 * stray chip behind the moment everything else was cleared.
 */
export const ClearChipsButton: FunctionComponent<ClearChipsButtonProps> = ({
	visible,
	onClear,
}) => {
	const { t } = useTranslation();

	if (!visible) {
		return null;
	}

	return (
		<button
			aria-label={t("onboardingTour.scoringStep.segments.clearChips")}
			className="ml-auto shrink-0 cursor-pointer self-center text-text-meta transition-colors duration-200 hover:text-status-error"
			title={t("onboardingTour.scoringStep.segments.clearChips")}
			type="button"
			onClick={onClear}
			onMouseDown={(event) => event.preventDefault()}
		>
			<Icon className="h-3.5 w-3.5" icon={faCircleXmark} />
		</button>
	);
};
